<template>
  <div>
    <div class="d-flex justify-end mb-4">
      <v-tooltip bottom v-if="selected && selected.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            depressed
            class="mb-2 mr-2 primary-button"
            dark
            @click="getZip"
          >
            {{ $t('Baixar certificados') }}
          </v-btn>
        </template>
        <span>{{ $t('Máximo de 25 arquivos por vez') }}</span>
      </v-tooltip>

      <v-btn color="primary-button" depressed @click="filters = !filters">
        {{ filters ? $t('Fechar filtros') : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="filters">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Instituição') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="institution.name"
              outlined
              class="primary-input"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Unidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.unidadeId"
              :items="unidades"
              item-value="id"
              item-text="name"
              outlined
              class="primary-input"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <label class="label">{{ $t('Setor') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.sectorIds"
              :items="departments"
              multiple
              item-value="id"
              item-text="name"
              :loading="departmentLoading"
              outlined
              class="primary-input"
              :search-input.sync="departmentSearch"
              @blur="departmentSearch = ''"
              clearable
              chips
              deletable-chips
              small-chips
            >
              <template v-slot:selection="{ attrs, index, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeSetor(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">{{ item.name }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Equipamento padrão') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.standardEquipmentIds"
              :items="standardEquipments"
              multiple
              item-value="id"
              item-text="name"
              :loading="standardEquipmentLoading"
              outlined
              class="primary-input"
              clearable
              chips
              deletable-chips
              small-chips
              :search-input.sync="equipamentSearch"
              @blur="equipamentSearch = ''"
            >
              <template v-slot:selection="{ attrs, index, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeStandardEquipment(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">{{ item.name }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Identificação') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.identification"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Código patrimônio') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.propertyCode"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Número de Série') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.serialNumber"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Equipamento') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.equipment"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Fabricante') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.manufacturer"
              :items="manufacturers"
              item-text="name"
              item-value="name"
              outlined
              append-icon="mdi-chevron-down"
              class="primary-input"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Modelo') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.model"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Nº O.S.') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.osNumber"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-row class="ma-0" no-gutters>
              <v-col cols="12" class="text-center">
                <label class="label">{{ $t('Data Checklist') }}</label>
              </v-col>
              <v-col>
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      placeholder="Inicial"
                      v-model="startDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="filter.initial = parseDate(startDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input mr-1"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="checklistStartDate"
                    min="1900-01-01"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="ma-0 py-0" cols="10" sm="5" md="5" lg="5">
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      placeholder="Final"
                      :disabled="!startDate"
                      v-model="endDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="filter.final = parseDate(endDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="checklistEndDate"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Checklist Validado') }}</label>
            <v-autocomplete
              single-line
              :items="[
                { text: $t('Sim'), value: true },
                { text: $t('Não'), value: false },
              ]"
              item-text="text"
              item-value="value"
              clearable
              hide-details="auto"
              v-model="filter.isValidated"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Aprovação') }}</label>
            <v-autocomplete
              single-line
              :items="[
                { text: $t('Sim'), value: true },
                { text: $t('Não'), value: false },
              ]"
              item-text="text"
              item-value="value"
              clearable
              hide-details="auto"
              v-model="filter.approved"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Categoria') }}</label>
            <v-autocomplete
              single-line
              :items="categories"
              item-text="text"
              item-value="value"
              clearable
              hide-details="auto"
              v-model="filter.category"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn
              class="mx-2 secondary-button"
              color="#BBCF20"
              depressed
              @click="list"
            >
              <span>{{ $t('Filtrar') }}</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>
            <v-btn
              depressed
              color="#20202066"
              class="clear-button mr-0"
              @click="reset"
            >
              <span>{{ $t('Limpar') }}</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-data-table
      :no-data-text="$t('Nenhum item encontrado')"
      class="main-table"
      :headers="headers"
      :items="checklists"
      show-select
      v-model="selected"
      :items-per-page="pageSize"
      hide-default-footer
      hide-default-header
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.executionDate`]="{ item }">
        {{ formatDate(item.executionDate) }}
      </template>

      <template #[`item.answerTemplate.type`]="{ item }">
        {{ $t(types[item.answerTemplate.type]) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :to="`/editServiceOrder/${item.serviceOrderId}`"
              :color="
                item.serviceOrder.closeServiceOrderDateTime
                  ? '#B9CE1E'
                  : '#F5F5F5'
              "
              dark
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon color="#2A8EA4" small> mdi-view-module </v-icon>
            </v-btn>
          </template>
          <span>Ordem de Serviço</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5"
              class="ma-1"
              color="#0F3565"
              dark
              :to="`/inspectionRoutineChecklist/manage?id=${item.id}`"
              target="_blank"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="institution.userType >= 0 && institution.userType <= 2 || institution.userType === 8">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              small
              color="#FF4F64"
              style="font-weight: bold"
              dark
              v-bind="attrs"
              v-on="on"
              depressed
              @click="confirmDelete(item)"
            >
              <v-icon small color="white"> mdi-trash-can-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              dark
              :to="`/inspectionRoutineChecklist/print?id=${item.id}`"
              target="_blank"
              :color="item.approved ? `#BBCF20` : `error`"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small color="#F5F5F5"> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.approved === false && institution.userType !== 4 && institution.userType !== 5">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              :color="getProactiveStatusColor(item)"
              @click.stop="handleProactiveClick(item)"
              style="cursor: pointer; font-weight: 900; font-size: 24px"
              v-bind="attrs"
              v-on="on"
              class="ml-1"
            >
              mdi-exclamation-thick
            </v-icon>
          </template>
          <span>{{ getProactiveStatusText(item) }}</span>
        </v-tooltip>
        <span v-else style="display: inline-block; width: 40px"></span>
      </template>
    </v-data-table>

    <v-dialog v-model="deleteDialog" max-width="400" persistent>
      <v-card class="card-pad text-center">
        <strong>{{ $t('Remover') }} Certificado</strong>

        <br />

        <div class="caption--text text-body-2 mb-4">
          {{ $t('Tem certeza de que deseja remover este certificado de rotina de inspeção?') }}
        </div>

        <v-btn
          depressed
          :disabled="deleteLoading"
          @click="deleteDialog = false"
          class="ma-1 secondary-button"
        >
          Cancelar
        </v-btn>

        <v-btn
          depressed
          :loading="deleteLoading"
          class="ma-1 quaternary-button"
          color="#FF4F64"
          @click="deleteChecklist"
        >
          {{ $t('Remover') }}
        </v-btn>
      </v-card>
    </v-dialog>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="checklists.length">
          <span> 1 - {{ checklists.length }} de {{ filter.totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="filter.totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  name: 'InspectionRoutineChecklistPage',

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.userType = this.institution.userType
    this.filter.institutionId = this.institutionId

    if (this.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getStandardEquipments(),
      this.getDepartments(),
      this.getManufacturers(),
    ])

    if (this.unidades.length === 1) {
      this.filter.unidadeId = this.unidades[0].id
    }

    this.list()
  },

  async activated() {
    const needsRefresh = localStorage.getItem(
      'refreshInspectionRoutineChecklistTable'
    )
    if (needsRefresh) {
      localStorage.removeItem('refreshInspectionRoutineChecklistTable')
      await this.list()
    }
  },

  data() {
    return {
      institution: {},
      institutionId: null,
      userType: null,
      loading: false,
      filters: false,
      departmentLoading: false,
      standardEquipmentLoading: false,
      departmentSearch: '',
      equipamentSearch: '',
      menuStartDate: false,
      menuEndDate: false,
      startDate: null,
      endDate: null,
      checklistStartDate: null,
      checklistEndDate: null,
      unidades: [],
      departments: [],
      standardEquipments: [],
      manufacturers: [],
      filter: {
        page: 1,
        pageSize: 20,
        category: null,
        unidadeId: null,
        sectorIds: null,
        standardEquipmentIds: null,
        identification: null,
        propertyCode: null,
        serialNumber: null,
        equipment: null,
        manufacturer: null,
        model: null,
        osNumber: null,
        initial: null,
        final: null,
        isValidated: null,
        approved: null,
      },
      page: 1,
      pageSize: 20,
      sizes: [10, 20, 30, 90, 180],
      checklists: [],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrder.number',
          sortable: false,
        },
        {
          text: 'Tipo',
          align: 'center',
          value: 'answerTemplate.type',
          sortable: false,
        },
        {
          text: 'Executado em',
          align: 'center',
          value: 'executionDate',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      types: ['Equipamento', 'Setor'],
      apiService: new ApiService(),
      generalService: new GeneralService(),
      selected: [],
      deleteDialog: false,
      deleteLoading: false,
      itemToDelete: null,
    }
  },

  computed: {
    categories() {
      return [
        { text: this.$t('Equipamento'), value: 0 },
        { text: this.$t('Setor'), value: 1 },
      ]
    },
  },

  methods: {
    removeSetor(index) {
      this.filter.sectorIds.splice(index, 1)
      this.filter.sectorIds = [...this.filter.sectorIds]
    },

    removeStandardEquipment(index) {
      this.filter.standardEquipmentIds.splice(index, 1)
      this.filter.standardEquipmentIds = [...this.filter.standardEquipmentIds]
    },

    async getUnidades() {
      try {
        const response = await this.apiService.get(`unidade/list/${this.institutionId}`)
        this.unidades = response.content
      } catch {
        this.$toast(this.$t('Erro ao carregar unidades'))
      }
    },

    async getUserUnidades() {
      try {
        const response = await this.apiService.get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        this.unidades = response.content
      } catch {
        this.$toast(this.$t('Erro ao carregar unidades'))
      }
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true
      try {
        this.standardEquipments =
          await this.generalService.getStandardEquipmentsByInstitution(
            this.institutionId
          )
      } finally {
        this.standardEquipmentLoading = false
      }
    },

    async getDepartments() {
      this.departmentLoading = true
      try {
        const response = await this.apiService.get(`department/listActive/${this.institutionId}`)
        this.departments = response.content
      } catch {
        this.$toast(this.$t('Erro ao carregar setores'))
      } finally {
        this.departmentLoading = false
      }
    },

    async getManufacturers() {
      try {
        const response = await this.apiService.get(`manufacturer/list/${this.institutionId}`)
        this.manufacturers = response.content
      } catch {
        this.$toast(this.$t('Erro ao carregar fabricantes'))
      }
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.checklistStartDate)
      this.filter.initial = this.checklistStartDate
      this.$refs.menuStartDate.save(date)
      this.endDate = this.formatInputDate(this.checklistEndDate)
      this.filter.final = this.checklistEndDate
      this.$refs.menuEndDate.save(date)
    },

    async getZip() {
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${this.selected.length} ${this.$t(
          'selecionados'
        )}`
      )
      const ids = this.selected.map((x) => x.id)
      try {
        const response = await this.apiService.post(`inspectionRoutineChecklist/getZipChecklist`, { ids })
        var pedfResult = 'data:application/zip;base64,' + response.content
        const link = document.createElement('a')
        link.href = pedfResult
        link.setAttribute('download', `Checklists`)
        document.body.appendChild(link)
        link.click()
        this.selected = []
      } catch {
        this.$toast(this.$t('Erro ao baixar certificados'))
      }
    },

    reset() {
      this.startDate = null
      this.endDate = null
      this.checklistStartDate = null
      this.checklistEndDate = null
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        category: null,
        institutionId: this.institutionId,
        unidadeId: null,
        sectorIds: null,
        standardEquipmentIds: null,
        identification: null,
        propertyCode: null,
        serialNumber: null,
        equipment: null,
        manufacturer: null,
        model: null,
        osNumber: null,
        initial: null,
        final: null,
        isValidated: null,
        approved: null,
      }
      this.list()
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    async list() {
      try {
        const response = await this.apiService.post('inspectionRoutineChecklist/list/paginate', this.filter)
        this.checklists = response.content.checklists
        this.filter.totalItems = response.content.pager.totalItems
        this.filter.totalPages = response.content.pager.totalPages
        await this.loadProactiveServiceOrdersStatus()
      } catch {
        this.$toast(this.$t('Erro ao carregar checklists'))
      }
    },

    async loadProactiveServiceOrdersStatus() {
      const checklistsWithProactive = this.checklists.filter(
        (c) => c.approved === false && c.correctiveProativeServiceOrderId
      )

      if (checklistsWithProactive.length === 0) return

      const promises = checklistsWithProactive.map(async (checklist) => {
        try {
          const response = await this.apiService.get(
            `serviceOrder/getServiceOrder/${this.institutionId}/${checklist.correctiveProativeServiceOrderId}`
          )

          if (response && response.content) {
            const index = this.checklists.findIndex(
              (c) => c.id === checklist.id
            )
            if (index !== -1) {
              this.$set(
                this.checklists[index],
                'correctiveProactiveServiceOrder',
                {
                  id: response.content.id,
                  status: response.content.status,
                  number: response.content.number,
                  closeServiceOrderDateTime:
                    response.content.closeServiceOrderDateTime,
                }
              )
            }
          }
        } catch (error) {
          console.error('Erro ao buscar status da O.S. proativa:', error)
        }
      })

      await Promise.all(promises)
    },

    getProactiveStatusColor(checklist) {
      if (!checklist.correctiveProativeServiceOrderId) {
        return 'grey'
      }

      if (checklist.correctiveProactiveServiceOrder) {
        const isClosed =
          checklist.correctiveProactiveServiceOrder
            .closeServiceOrderDateTime !== null
        return isClosed ? '#B9CE1E' : '#d3ba00'
      }

      return '#d3ba00'
    },

    getProactiveStatusText(checklist) {
      if (!checklist.correctiveProativeServiceOrderId) {
        return this.$t('Criar O.S. Corretiva Proativa')
      }

      if (checklist.correctiveProactiveServiceOrder) {
        const isClosed =
          checklist.correctiveProactiveServiceOrder
            .closeServiceOrderDateTime !== null
        return isClosed
          ? this.$t('O.S. Corretiva Proativa finalizada')
          : this.$t('O.S. Corretiva Proativa em andamento')
      }

      return this.$t('Abrir O.S. Corretiva Proativa')
    },

    handleProactiveClick(checklist) {
      if (!checklist.correctiveProativeServiceOrderId) {
        this.createProactiveServiceOrder(checklist)
      } else {
        this.openProactiveServiceOrder(checklist)
      }
    },

    createProactiveServiceOrder(checklist) {
      const currentUser = JSON.parse(localStorage.getItem('user'))
      const serviceOrder = checklist.serviceOrder
      const categories = ['Equipamento', 'Setor']
      const categoryStr =
        typeof serviceOrder.category === 'number'
          ? categories[serviceOrder.category] || serviceOrder.category
          : serviceOrder.category

      const proactiveServiceOrderData = {
        parentServiceOrderId: serviceOrder.id,
        parentServiceOrderNumber: serviceOrder.number,

        institutionId: this.institution.id,
        unidadeId: serviceOrder.unidadeId,
        category: categoryStr,
        name: serviceOrder.name,
        serviceOrderType: 'Corretiva',
        isProactive: true,

        requestDateTime: new Date(),

        request: serviceOrder.request,

        responsibleName: serviceOrder.responsibleName,

        requester: currentUser.name,

        equipmentId:
          categoryStr === 'Equipamento'
            ? serviceOrder.equipmentId
            : null,

        departmentId:
          categoryStr === 'Setor' ? serviceOrder.departmentId : null,
        subDepartmentId:
          categoryStr === 'Setor'
            ? serviceOrder.subDepartmentId
            : null,

        workshopId: serviceOrder.workshopId,
        costCenterId: serviceOrder.costCenterId,
        internalTeam: serviceOrder.internalTeam,
        isExternal: serviceOrder.isExternal,
        correctiveProativeServiceOrderId: serviceOrder.id,
        inspectionRoutineChecklistId: checklist.id,
      }

      localStorage.removeItem('proactiveServiceOrder')
      localStorage.setItem(
        'proactiveServiceOrder',
        JSON.stringify(proactiveServiceOrderData)
      )
      localStorage.setItem('refreshInspectionRoutineChecklistTable', 'true')

      window.location.href = '/newServiceOrder'
    },

    openProactiveServiceOrder(checklist) {
      if (checklist.correctiveProativeServiceOrderId) {
        localStorage.setItem('refreshInspectionRoutineChecklistTable', 'true')
        window.location.href =
          '/editServiceOrder/' + checklist.correctiveProativeServiceOrderId
      }
    },

    confirmDelete(item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    async deleteChecklist() {
      this.deleteLoading = true
      try {
        await this.apiService.delete(`InspectionRoutineChecklist/remove/${this.itemToDelete.id}`)
        this.$toast(this.$t('Certificado excluído!'))
        this.deleteDialog = false
        this.itemToDelete = null
        this.list()
      } catch (e) {
        this.$toast(this.$t('Erro ao excluir certificado'))
      } finally {
        this.deleteLoading = false
      }
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.filter.page = 1
        this.list()
      }
    },
    selected(val) {
      if (val.length > 25) {
        this.$nextTick(() => {
          this.selected = val.slice(0, 25)
        })
      }
    },
    page() {
      this.filter.page = this.page
      this.list()
    },
  },
}
</script>

<style></style>
